exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".antwoordOuter{background-color:#f3f3f6;width:100%}.antwoordInner{padding:20px 20px 10px 20px}", ""]);

// exports
